import React from 'react';
import {useParams} from 'react-router-dom';
import CompanyDetails from '@/components/admin/companies/details';
import {useAppSelector} from '@/redux-store/store';
import NotFound from '@/pages/not-found';
import Layout from '@/components/layout/main-layout';
import {Container} from '@mui/material';
import ScrollToTop from '@/components/ui/scroll-to-top';
import {CompanyProvider} from '@/contexts/admin/companies';

const AdminCompanyDetailsPage: React.FC = () => {
  const {companyId} = useParams<{companyId: string}>();

  const companyFromRedux = useAppSelector((state) => state.company.company);

  const hasCompanyId = companyId ? true : false;

  const userRole = useAppSelector((state) => state.auth.keycloakUser?.userRole);
  const isAdmin = userRole && userRole === 'ADMIN';
  const userCompany = useAppSelector((state) => state.company.company);
  const adminCompanies = useAppSelector(
    (state) => state.adminCompanies.adminCompanies
  );
  const company = isAdmin
    ? adminCompanies.find((c) => c._id === companyId)
    : userCompany;

  const companyIdToUse = hasCompanyId ? companyId : companyFromRedux._id;

  const firstTranslationKey = hasCompanyId
    ? 'admin_dashboard'
    : 'company_management';

  if (company) {
    return (
      <Layout
        company={company}
        firstTranslationKey={firstTranslationKey}
        skipBreadcrumb={2}
      >
        <Container
          maxWidth={'md'}
          sx={{
            pt: 2,
            marginTop: 1,
            position: 'relative'
          }}
        >
          <CompanyProvider companyId={companyIdToUse}>
            <CompanyDetails company={company} hasCompanyId={hasCompanyId} />
          </CompanyProvider>
          <ScrollToTop />
        </Container>
      </Layout>
    );
  }
  return <NotFound />;
};

export default AdminCompanyDetailsPage;
